import { getMergedOptionGroupOptions } from 'shared-helpers/customAttributes';

import type {
  Locales,
  LocaleMessages,
  UserCustomAttribute,
  UserCustomAttributes
} from 'shared-types';

interface Props {
  attribute: Pick<UserCustomAttribute, 'type' | 'optionGroups'>;
  language: Locales;
  messages: LocaleMessages;
  value: UserCustomAttributes['key'];
}

const getUserCustomAttributeStringValue = ({
  attribute,
  language,
  messages,
  value
}: Props) => {
  if (attribute.type === 'ArrayWithOptions' && Array.isArray(value)) {
    const mergedOptions = getMergedOptionGroupOptions({
      language,
      optionGroups: attribute.optionGroups
    });
    return value
      .map((valueItem) => {
        const matchingOption = mergedOptions.find(
          (option) => option.key === valueItem
        );
        if (matchingOption) return matchingOption.label;
        return valueItem;
      })
      .join(', ');
  } else if (attribute.type === 'StringWithOptions') {
    const mergedOptions = getMergedOptionGroupOptions({
      language,
      optionGroups: attribute.optionGroups
    });
    const matchingOption = mergedOptions.find((option) => option.key === value);
    if (matchingOption) return matchingOption.label;
  } else if (attribute.type === 'Array') {
    return Array.isArray(value) ? value.join(', ') : value?.toString() || '';
  } else if (attribute.type === 'Boolean') {
    if (typeof value === 'boolean') {
      return value ? messages.commonYes : messages.commonNo;
    }
  }

  return value?.toString() || '';
};

export default getUserCustomAttributeStringValue;
